/**
 * Klient `POST /v1/duediligence/cases/:id/answers` (krok U1 - odpovedi maklere
 * pres API). Krok S3: jedno API, jeden typovany klient (`lib/api.ts`).
 */

import { apiClient } from './api.js';
import { unwrap } from './api-error.js';

export type AnswerSourceKind = 'CLIENT_STATEMENT' | 'AUTHORITY_STATEMENT' | 'DOCUMENT' | 'BROKER_FINDING';
export type AnswerDemolitionRoofKind = 'TILES' | 'ASBESTOS' | 'METAL' | 'UNKNOWN';
export type AnswerAccessPassageKind = 'GATE' | 'WALL' | 'OPEN';

export interface AnswerStructuredInput {
  readonly roof?: AnswerDemolitionRoofKind;
  readonly eaveHeightM?: number;
  readonly ridgeHeightM?: number;
  readonly passageKind?: AnswerAccessPassageKind;
  readonly demolish?: boolean;
}

export interface SubmitCaseAnswerInput {
  readonly questionId: string;
  readonly source: AnswerSourceKind;
  readonly text: string;
  /** ISO datum/cas, ke kteremu odpoved plati (muze byt zpetne) - default now() na serveru. */
  readonly answeredAt?: string;
  readonly structured?: AnswerStructuredInput;
}

export interface SubmitCaseAnswerResult {
  readonly question: { readonly id: string; readonly status: string };
  readonly fact: { readonly id: string; readonly factKey: string };
  readonly demolitionFact: { readonly id: string; readonly factKey: string } | null;
}

export async function submitCaseAnswer(
  caseId: string,
  input: SubmitCaseAnswerInput,
): Promise<SubmitCaseAnswerResult> {
  return unwrap(
    apiClient.POST('/v1/duediligence/cases/{id}/answers', {
      params: { path: { id: caseId } },
      body: input,
    }),
  ) as Promise<SubmitCaseAnswerResult>;
}
